import { getLocalStorage } from "./LocalStorageHandler";

export function getLocationId() {
  const sessionData = getLocalStorage("sessionData");
  return sessionData?.locationid ?? sessionData?.locationId ?? null;
}

export function getOrganizationId() {
  const sessionData = getLocalStorage("sessionData");
  return sessionData?.organizationid ?? null;
}

export function getLogginedPersonId() {
  const sessionData = getLocalStorage("sessionData");
  return sessionData?.personId ?? null;
}

export function getRegistrationType() {
  const sessionData = getLocalStorage("sessionData");
  return sessionData?.registrationType ?? null;
}